import './index.scss';

import {
  Button,
  Header,
} from '@cloudscape-design/components';
import {
  OrderStatus,
  OrderTypes,
} from '@parallel-fluidics/shared/constants';
import CollapsedViewToggle from 'components/Trackers/collapsedViewToggle';
import PageContent from 'components/Trackers/pageContent';
import {
  collection,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';
import useOrderFilter from 'hooks/use-orderFilter';
import useRealtimeDocs from 'hooks/use-realtimeDocs';
import React, {
  useMemo,
} from 'react';
import { useNavigate } from 'react-router-dom';

import TrackersProvider from './trackersProvider';

export default function ActiveTrackersPage() {
  const navigate = useNavigate();
  const { orderType, FilterButtons } = useOrderFilter();

  const orderQuery = useMemo(() => {
    if (orderType) {
      return query(
        collection(getFirestore(), 'orders'),
        where('status', '==', OrderStatus.IN_PROGRESS),
        where('isInternal', '==', orderType === OrderTypes.INTERNAL),
      );
    }
    return query(
      collection(getFirestore(), 'orders'),
      where('status', '==', OrderStatus.IN_PROGRESS),
    );
  }, [orderType]);

  const { data: activeOrders } = useRealtimeDocs({ query: orderQuery });

  return (
    <div className="trackerPage">
      <Header
        actions={(
          <Button variant="normal" onClick={() => { navigate('/trackers/shipped'); }}>See shipped orders</Button>
        )}
        data-element="header"
      >
        <div className="headingAndFilter">
          <div className="heading">Active Orders</div>
          <FilterButtons />
        </div>
      </Header>
      <TrackersProvider orders={activeOrders}>
        <div className="optionsBar">
          <CollapsedViewToggle />
        </div>
        <PageContent />
      </TrackersProvider>
    </div>
  );
}
